import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    $('a.ot-sdk-show-settings').on('click', (e) => {
        e.preventDefault();
    });
});
